module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_south-ossetia-09b036d8101ce1147f4d5b4b636f52ef.png";